module.exports = __webpack_public_path__ + "img/main-top-min.0f78b1c1.png";